export const characters = {
  title: "Characters",
  subtitle: "Create and manage characters to automate your tasks",
  newCharacter: "New Character",
  noCharacters: "No characters found",
  edit: "Edit",
  delete: "Delete",
  name: "Name",
  description: "Description",
  systemPrompt: "System Prompt",
  temperature: "Temperature",
  model: "Model",
  tools: "Tools",
  create: "Create Character",
  table: {
    title: "Name",
    description: "Description",
    tools: "Tools",
    actions: "Actions",
    public: "Public",
    private: "Private",
  },
  actions: {
    edit: "Edit",
    delete: "Delete",
    chat: "Chat with the character",
  },
  profilePicture: "Profile Picture (URL)",
  tagline: "Tagline",
  greeting: "Greeting",
  public: "Public",
  update: "Update",
};
